// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"e64d9b76","330":"945f5943","383":"9c5adbd8","546":"0429be2d"}[chunkId] + ".chunk.js";
};